/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Youshouldgrantdataroomaccess6Inputs */

const en_coinvestments_youshouldgrantdataroomaccess6 = /** @type {(inputs: Coinvestments_Youshouldgrantdataroomaccess6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Note: You should grant data room access in your external software`)
};

/**
* | output |
* | --- |
* | "Note: You should grant data room access in your external software" |
*
* @param {Coinvestments_Youshouldgrantdataroomaccess6Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_youshouldgrantdataroomaccess6 = /** @type {((inputs?: Coinvestments_Youshouldgrantdataroomaccess6Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Youshouldgrantdataroomaccess6Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_youshouldgrantdataroomaccess6(inputs)
});
export { coinvestments_youshouldgrantdataroomaccess6 as "coInvestments_youShouldGrantDataRoomAccess" }